import { render } from "./inProgram.vue?vue&type=template&id=479ea997&scoped=true"
import script from "./inProgram.vue?vue&type=script&lang=js"
export * from "./inProgram.vue?vue&type=script&lang=js"

import "./inProgram.vue?vue&type=style&index=0&id=479ea997&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479ea997"]])

export default __exports__